import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const caption = css`
  font-style: italic;
  text-transform: uppercase;
`
export const toggle = css`
  padding-inline-start: ${spacing(1)}; // 8px
`
